import bretImage from '@/assets/images/userImages/bret.svg';
import alexanderImage from '@/assets/images/userImages/alexander.svg';
import chrisImage from '@/assets/images/userImages/chris.svg';
import { billingPeriodMap } from '@/utils/billingPeriodUtils';

export { billingPeriodMap };

export const billingTabs = [
  {
    label: 'Monthly',
    value: 'monthly',
    isAnnual: false,
    discount: 0,
  },
  {
    label: 'Quarterly',
    value: 'quarterly',
    isAnnual: false,
    discount: 10,
  },
  {
    label: 'Semi-annually',
    value: 'semi_annual',
    isAnnual: false,
    discount: 10,
  },
  {
    label: 'Annually',
    value: 'annual',
    isAnnual: true,
    discount: 20,
  },
  {
    label: '2 years',
    value: 'two_year',
    isAnnual: true,
    discount: 30,
  },
];

export const billingTabsV3 = [
  {
    label: 'Monthly',
    value: 'monthly',
    isAnnual: false,
    discount: 0,
  },
  {
    label: 'Quarterly',
    value: 'quarterly',
    isAnnual: false,
    discount: 10,
  },
  {
    label: 'Annually',
    value: 'annual',
    isAnnual: true,
    discount: 30,
  },
];

export const billingPlans = [
  {
    id: 'free',
    name: 'Free',
    annualPrice: 0,
    annualPriceText: '$0',
    annualPriceSub: 'Per user, per month',
    annualCredits: '300 credits / month',
    monthlyPrice: 0,
    monthlyPriceText: '$0',
    monthlyPriceSub: 'Per user, per month',
    monthlyCredits: '300 credits / month',
    features: ['Access to all SuperAGI Apps (Lite version)'],
  },
  {
    id: 'starter',
    name: 'Starter',
    annualPrice: 7,
    annualPriceText: '$7',
    annualPriceSub: 'Per user, per month\nBilled Annually',
    annualCredits: '4,100 credits / year',
    monthlyPrice: 9,
    monthlyPriceText: '$9',
    monthlyPriceSub: 'Per user, per month\nBilled Monthly',
    monthlyCredits: '300 credits / month',
    features: [
      'AI-Native CRM',
      'Power Dialer',
      'AI Journeys',
      'Conversational Intelligence (lite)',
      'Multi-Channel AI Sequences (up to 5)',
      'Deals + Custom Properties',
      'AI SDR (Email + LinkedIn)',
      'Marketing Campaigns',
      'Live Chat',
      'Real Time Intent Signals (20 leads/day)',
      'Email Support',
      'and more...',
    ],
  },
  {
    id: 'growth',
    name: 'Starter',
    annualPrice: 47,
    annualPriceText: '$47',
    annualPriceSub: 'Per user, per month\nBilled Annualy',
    annualCredits: '24,000 credits / year',
    monthlyPrice: 59,
    monthlyPriceText: '$59',
    monthlyPriceSub: 'Per user, per month\nBilled Monthly',
    monthlyCredits: '2,000 credits / month',
    features: ['Access to all SuperAGI Apps', 'Basic Integrations', 'Basic Analytics', 'Support Resolution in 72 hours'],
  },
  {
    id: 'pro',
    name: 'Business',
    annualPrice: 119,
    annualPriceText: '$119',
    annualPriceSub: 'Per user, per month\nBilled Annualy',
    annualCredits: '66,000 credits / year',
    monthlyPrice: 149,
    monthlyPriceText: '$149',
    monthlyPriceSub: 'Per user, per month\nBilled Monthly',
    monthlyCredits: '5,500 credits / month',
    features: [
      'Access to all SuperAGI Apps',
      'Role based access control',
      'Audit Logs',
      'Advanced Integrations',
      'Advanced Analytics',
      'Onboarding Support',
      'Customer Success Manager',
      'Priority Support with <24 hours resolution time',
      'External API access (Rate Limited)',
    ],
  },
  {
    id: 'custom',
    name: 'Enterprise',
    annualPrice: 0,
    annualPriceText: "Let's Talk",
    annualPriceSub: 'Specific needs tailored to your business usecase',
    annualCredits: 'Custom credits',
    monthlyPrice: 0,
    monthlyPriceText: "Let's Talk",
    monthlyPriceSub: 'Specific needs tailored to your business usecase',
    monthlyCredits: 'Custom credits',
    features: [
      'Everything in Business +',
      'API Access with No Rate Limiting',
      'SAML SSO',
      'User Provisioning (SCIM)',
      'Advanced Security & Controls',
      'Customization & Solutioning Support',
      'and more...',
    ],
  },
];

export const CrmComparisonHeaders = ['CRM', 'FREE', 'GROWTH', 'PRO'];
export const CrmComparisonRows = [
  ['Agentic CRM', 'Basic', 'Advanced (workflows, playbooks)', 'Advanced (workflows, playbooks)'],
  ['Record limit', '50,000', 'Unlimited', 'Unlimited'],
  ['Prospects added/day', '25', 'Unlimited', 'Unlimited'],
  ['Meeting agents', '2', 'Unlimited + Conversational Intelligence', 'Unlimited + Conversational Intelligence'],
  ['Deals', 'Basic Kanban', 'Full Kanban + Win/Loss AI', 'Full Kanban + Win/Loss AI'],
  ['Chrome Extension', 'Add Leads from LinkedIn', 'I-Assistant + Market Research', 'I-Assistant + Market Research'],
];

export const AIComparisonHeaders = ['AI', 'FREE', 'GROWTH', 'PRO'];
export const AIComparisonRows = [
  ['I-Assistant', '10 msgs/day', 'Unlimited', 'Unlimited'],
  ['Agent Builder', '2 agents', 'Unlimited', 'Unlimited'],
  ['AI Voice Agents', '1', 'Unlimited', 'Unlimited'],
  ['Qualification Agent', '1', 'Unlimited', 'Unlimited'],
  ['Conversational Intelligence', false, 'Full notes + automatic task creation', 'Full notes + automatic task creation'],
  ['Call Intelligence', false, 'Basic', 'Full analytics + coaching'],
  ['Deal Intelligence', false, false, 'Deal & Pipeline scoring'],
  ['Real-time intent signals', '5 leads/day', 'Unlimited', 'Unlimited'],
  ['AI Lead Scoring', false, 'Advanced', 'Advanced'],
  ['AI Email Agent', '1', 'Unlimited', 'Unlimited'],
  ['AI LinkedIn Agent', '1', 'Unlimited', 'Unlimited'],
  ['AI Analytics', false, false, 'Advanced'],
];

export const ExecutionComparisonHeaders = ['EXECUTION', 'FREE', 'GROWTH', 'PRO'];
export const ExecutionComparisonRows = [
  ['E-mail slots per user', '1', 'Unlimited', 'Unlimited'],
  ['Daily send limit', '100', 'Unlimited*', 'Unlimited*'],
  ['E-mail providers', 'All', 'All', 'All'],
  ['Track website visitors', '30 / day', 'Unlimited', 'Unlimited'],
  ['AI Journeys', '2', 'Unlimited + A/B testing', 'Unlimited + A/B testing'],
  ['AI SDR', '2 campaigns', 'Unlimited campaigns', 'Unlimited campaigns'],
  ['Dialer', false, 'Power Dialer', 'Power + Parallel Dialer + Call Intelligence'],
];

export const MarketingComparisonHeaders = ['MARKETING', 'FREE', 'GROWTH', 'PRO'];
export const MarketingComparisonRows = [
  ['Campaigns', false, 'Email, SMS, Whatsapp (Soon)', 'Email, SMS, Whatsapp (Soon)'],
  ['Customer Journeys', false, 'Cross-channel + AI optimization', 'Cross-channel + AI optimization'],
  ['A/B Testing', false, true, true],
];

export const SupportComparisonHeaders = ['SUPPORT', 'FREE', 'GROWTH', 'PRO'];
export const SupportComparisonRows = [
  ['Live Chat (widget)', false, 'AI Live Chat Agent (autonomous)', 'AI Live Chat Agent (autonomous)'],
  ['Support Inbox', false, 'AI Support Inbox (triage, auto-resolve)', 'AI Support Inbox (triage, auto-resolve)'],
];

export const AnalyticsComparisonHeaders = ['ANALYTICS & REPORTING', 'FREE', 'GROWTH', 'PRO'];
export const AnalyticsComparisonRows = [
  ['Pre-built dashboards', 'Basic', 'Advanced', 'Advanced'],
  ['Goal tracking', 'Basic', 'Advanced', 'Advanced'],
  ['Custom dashboards', '1', 'Unlimited', 'Unlimited'],
];

export const OpsComparisonHeaders = ['OPS & SECURITY', 'FREE', 'GROWTH', 'PRO'];
export const OpsComparisonRows = [
  ['Multi-factor auth', false, true, true],
  ['Custom roles', false, 'Custom', 'Custom'],
  ['RBAC', false, 'Full RBAC', 'Full RBAC'],
];

export const ServiceSuccessComparisonHeaders = ['SERVICE & SUCCESS (FROM SUPERAGI)', 'FREE', 'GROWTH', 'PRO'];
export const ServiceSuccessComparisonRows = [
  ['Support channel', 'Community', 'Email support', 'Priority chat + email'],
  ['SLA', false, '1 hour', '15 mins'],
  ['Dedicated CSM', false, false, '≥ 5 seats'],
];

export const customerReviews = [
  {
    review:
      "SuperSales has given us the visibility and control we needed to achieve consistent growth. It is super easy to navigate and is simply a one stop shop for all of our company's marketing and sales needs. There is absolutely nothing out there like it!!",
    name: 'Bre T',
    userName: 'Bre T',
    designation: 'Co-Founder, Telecommunications',
    avatar: bretImage,
  },
  {
    review:
      "Since starting SuperMarketing, we've seen a significant boost in customer engagement and retention. The email automation tools are easy to set up, and the segmentation options let us deliver highly targeted messages to the right people at the right time.",
    name: 'Alexander W',
    userName: 'Alexander W',
    designation: 'Co-Founder, Telecommunications',
    avatar: alexanderImage,
  },
  {
    review:
      "The fact that it's literally an AI based software company behind it speaks volumes about the speed in which it should continue to move towards the future with new features that we are excited to see and try for our marketing outreach.",
    name: 'Chris T',
    userName: 'Chris T',
    designation: 'Co-Founder',
    avatar: chrisImage,
  },
];

export const billingFAQ = [
  {
    question: 'What are Seats?',
    answer: `A Seat is a paid user license that grants one person full access to your SuperAGI workspace. In the US and other regions a Seat costs $900 per user per year, billed annually. In India a Seat costs ₹1,500 per user per month or ₹16,000 per user per year. A Seat is charged in full the moment it is added—there is no proration.\n\nYou can lower the seat count effective on the next billing cycle, but never below the number of active members.\n\nIf your workspace uses domain auto-join or an admin invites someone when no free seats remain, a new seat is automatically purchased and billed immediately.`,
  },
  {
    question: 'What are Credits?',
    answer: `SuperAGI uses a credit-based billing system where all actions performed by users consume Credits. Credits are required for every action, whether it's sending emails, making calls, automating workflows, or generating AI-powered content and using digital workers.\n\nUsers can purchase Credit Packs based on their usage needs. Every user automatically receives 300 Credits for free each month, and users can buy additional Credit Packs if they require more credits beyond their default allocation.\n\nAll credits, including additional Credit Packs, expire at the end of each billing cycle and do not roll over. Credits are automatically replenished at the start of each new billing cycle.`,
  },
  {
    question: 'How are Seats & Credits allocated?',
    answer: [
      'Seats:',
      '• Every workspace automatically receives 2,500 Credits per user each month on the annual plan ($900 per user per year). In India the allocation is 500 Credits per user each month (₹1,500 per user per month) or 6,000 Credits per user each year (₹16,000 per user per year).',
      '• You choose how many seats you need when upgrading to the Paid Plan.',
      '• Adding a user when no free seats remain immediately purchases one new seat ($900 per year, or ₹1,500 per month / ₹16,000 per year in India) and adds it to your subscription.',
      '',
      'Credits:',
      '• Free Plan: Every workspace automatically receives 300 Credits each month.',
      '• Credit Pack (Paid Plan): $900 per user per year for 2,500 Credits per user each month, shared across all products. In India: ₹1,500 per user per month for 500 Credits, or ₹16,000 per user per year for 6,000 Credits.',
      '• Paid workspaces can buy as many Credit Packs as they like. Additional packs are billed in full immediately and also expire at cycle-end.',
    ],
  },
  {
    question: 'Do credits roll over to the next month?',
    answer: `No, credits do not roll over to the next billing cycle. Unused credits expire at the end of the billing period, including additional Credit Packs that were purchased separately.\n\nA fresh allocation of credits is provided at the beginning of each billing cycle based on the Credit Packs in the account.`,
  },
  {
    question: 'Can I purchase additional seats or credits mid-cycle?',
    answer: `Yes. When you add a Seat in the middle of your billing cycle the full seat charge is applied immediately, the Seat becomes active right away, and your renewal date does not change.\n\nIf you buy a Credit Pack mid-cycle the charge is also applied immediately, the new Credits appear in your balance at once, and they still expire at the current cycle-end.`,
  },
  {
    question: 'How does billing work across multiple SuperAGI products?',
    answer: `SuperAGI follows a single billing cycle across all products. This means that users receive one invoice per billing period covering all products and credit allocations.\n\nIf a user adds a new product (such as SuperMarketing) mid-cycle, it will be aligned with their existing billing cycle, and a prorated charge will apply for the remaining period. This ensures that all products remain on a unified billing schedule.`,
  },
  {
    question: 'How do I manage my billing and subscriptions?',
    answer: [
      'Users can access the Billing Dashboard to manage their invoices, track credit usage, and adjust their subscriptions. From the dashboard, users can:',
      '• View active subscriptions across all SuperAGI products',
      '• Purchase additional Credit Packs',
      '• Track Credit consumption in real-time',
      '• Update payment methods and billing details',
      '• Download invoices and manage past payments',
      '',
      'All subscription changes take effect immediately or at the next billing cycle, depending on the action taken.',
    ],
  },
  {
    question: 'What happens if I downgrade my subscription?',
    answer: `If a user reduces their Credit Packs mid-cycle, the credits remain active until the end of the billing period. The change will be reflected in the next invoice, ensuring that users do not lose access before the cycle ends.\n\nThere are no mid-cycle refunds for downgrading or removing Credit Packs.`,
  },
  {
    question: 'Are there any additional fees I should be aware of?',
    answer: `SuperAGI follows a transparent pricing structure with no hidden fees.\n\nIf a user runs out of credits, all software and AI actions will pause until more credits are purchased or the next cycle begins.`,
  },
  {
    question: 'How do I track my credit usage?',
    answer: [
      'Users can track their Credit consumption in real-time from the Credit Usage Dashboard. The dashboard displays:',
      '• Current available Credits',
      '• Credits consumed per action (email sending, enrichment, etc.)',
    ],
  },
  {
    question: 'What happens if my credits run out?',
    answer: `If a user exhausts their Credits, all actions will pause until new credits are added or the next cycle begins.`,
  },
  {
    question: 'What happens if I add or remove Credit Packs in the middle of a billing cycle?',
    answer: `Adding a pack triggers an immediate $49 charge, the Credits are applied at once, and they expire at the current cycle-end. Removing a pack leaves it active until cycle-end, and the lower pack count is reflected on the next invoice.`,
  },
  {
    question: 'What happens if my payment fails?',
    answer: `If a payment fails, SuperAGI will attempt to retry the charge for five days. Users will receive in-app notifications prompting them to update their payment method.\n\nIf payment is not completed within five days, access to paid features will be paused until the payment issue is resolved.`,
  },
  {
    question: 'How can I contact support for billing-related questions?',
    answer: ['For billing-related inquiries, users can:', '• Email support@superagi.com for assistance.'],
  },
];

export const creditConsumptionData = [
  {
    action: 'CRM Records',
    credits: '1 credit per 10 records monthly',
    tooltip: 'Records created in CRM via direct creation in CRM, Sequences, Workflows, Leads created via Meeting router, Prospect, Webhooks',
  },
  { action: 'Customer Success Tasks', credits: '1 credit per 10 records' },
  { action: 'Customer Support Tickets', credits: '1 credit per 10 records' },
  { action: 'Project Tasks', credits: '1 credit per 10 records' },
  { action: 'Sequence Tasks', credits: '1 credit per 10 records' },
  { action: 'Enrich Phone Number', credits: '10 credits per phone number' },
  { action: 'Enrich Email', credits: '1 credit per email' },
  { action: 'Enrich Companies', credits: '1 credit per company' },
  { action: 'Mailbox Purchase', credits: '2100 credits per mailbox per year' },
  {
    action: 'Domain Cost',
    credits: 'Depends on domain type (starts at 700 per domain per year)',
  },
  {
    action: 'Dialer Pricing',
    credits: 'Check here',
    link: 'https://billing.superagi.com/call_pricing',
  },
  { action: 'Email Sent', credits: '2 credits per 100 emails sent' },
  {
    action: 'WhatsApp Message Sent',
    credits: '1 credit per 20 WhatsApp messages sent + Standard Meta charges',
  },
  { action: 'Voice Agent', credits: '8 credits per minute' },
  { action: 'Anonymous Website Visitor', credits: '10 credits per lead' },
  { action: 'Post from Thought Leaders', credits: '20 credits per lead' },
  { action: 'Post from Target Company', credits: '20 credits per lead' },
  {
    action: 'Recent Job Changes',
    credits: '20 credits per lead x No. of times they change',
  },
  {
    action: 'Person Mentioned in News',
    credits: '20 credits per news notification',
  },
  {
    action: 'Company Mentioned in News',
    credits: '20 credits per news notification',
  },
  { action: 'Job Posting by Company', credits: '20 credits per job posting' },
  {
    action: 'New Funding Announcement',
    credits: '20 credits per funding announcement',
  },
  { action: 'AI-Generated Email', credits: '2 credits per email' },
  {
    action: 'Reasons to Engage',
    credits: '~2 credits per lead',
    tooltip: 'Actionable triggers (based on real time activities, intent signals, external events) which help you reach out at the right time, with the right message',
  },
  { action: 'Contact Market Research', credits: '~2 credits per lead' },
  { action: 'Company Market Research', credits: '~2 credits per company' },
  { action: 'Qualification Agent', credits: '~10 credits per lead' },
  {
    action: 'Call Prep Summary',
    credits: '~1 credit per lead',
    tooltip:
      'Provides a concise, AI-generated overview of the most important information needed before a call (about contact/company, previous call outcomes, recent interactions, open tasks/tickets)',
  },
  {
    action: 'Meeting Agent',
    credits: '25 credits per meeting booked',
    tooltip: 'Meetings booked via meeting agent, meeting router',
  },
  { action: 'Workflow', credits: '1 credit per 5 executions' },
  { action: 'Process Design', credits: '1 credit per 5 executions' },
  {
    action: 'Sequence - Step Execution',
    credits: '1 credit per 5 steps executed',
  },
  { action: 'I-Assistant', credits: '~1 credit per message' },
  { action: 'Form Responses (Internal)', credits: '1 credit per 10 responses' },
  {
    action: 'Routing Form Responses (External)',
    credits: '1 credit per 10 responses',
  },
  {
    action: 'Customer Success - Alerts',
    credits: '10 credits per alert agent created',
  },
  {
    action: 'Customer Support - Live Chat Widget',
    credits: '100 credits per conversation closed by AI',
  },
  { action: 'AI Notetaker - Transcription', credits: '2 credits per minute' },
  {
    action: 'Vibe Coder',
    credits: 'Credits based on AI compute used per generation',
    tooltip: 'Credits vary depending on the complexity of the AI task, length of input/output, and compute required',
  },
  {
    action: 'AI Consumption',
    credits: 'Credits based on AI compute used per request',
    tooltip:
      'Credits vary depending on the complexity of the AI task, length of input/output, and compute required (Cold Outreach (AI Usage), Sequences (Qualification Agent), Prospect (AI Search), Customer Success, AI Notetaker (Conversation Intelligence))',
  },
];

export const billingFAQv4 = [
  {
    question: 'What are Credits?',
    answer: `SuperAGI uses a credit-based billing system where all actions performed by users consume Credits. Credits are required for every action, whether it's sending emails, making calls, automating workflows, or generating AI-powered content and using digital workers.\n\nUsers can purchase Credit Packs based on their usage needs. Every user automatically receives 300 Credits for free each month, and users can buy additional Credit Packs if they require more credits beyond their default allocation.\n\nAll credits, including additional Credit Packs, expire at the end of each billing cycle and do not roll over. Credits are automatically replenished at the start of each new billing cycle.`,
  },
  {
    question: 'Do credits roll over to the next month?',
    answer: `Yes the credits do not expire and they will stay in the workspace.`,
  },
  {
    question: 'How does billing work across multiple SuperAGI products?',
    answer: `SuperAGI follows a single billing cycle across all products. This means that users receive one invoice per billing period covering all products and credit allocations.\n\nIf a user adds a new product (such as SuperMarketing) mid-cycle, it will be aligned with their existing billing cycle, and a prorated charge will apply for the remaining period. This ensures that all products remain on a unified billing schedule.`,
  },
  {
    question: 'How do I manage my billing and subscriptions?',
    answer: [
      'Users can access the Billing Dashboard to manage their invoices, track credit usage, and adjust their subscriptions. From the dashboard, users can:',
      '• View active subscriptions across all SuperAGI products',
      '• Track Credit consumption in real-time',
      '• Update payment methods and billing details',
      '• Download invoices and manage past payments',
      '',
      'All subscription changes take effect immediately or at the next billing cycle, depending on the action taken.',
    ],
  },
  {
    question: 'Are there any additional fees I should be aware of?',
    answer: `SuperAGI follows a transparent pricing structure with no hidden fees.\n\nIf a user runs out of credits, all software and AI actions will pause until more credits are purchased or the next cycle begins.`,
  },
  {
    question: 'How do I track my credit usage?',
    answer: [
      'Users can track their Credit consumption in real-time from the Credit Usage Dashboard. The dashboard displays:',
      '• Current available Credits',
      '• Credits consumed per action (email sending, enrichment, etc.)',
    ],
  },
  {
    question: 'What happens if my credits run out?',
    answer: `If a user exhausts their Credits, all actions will pause until new credits are added or the next cycle begins.`,
  },
  {
    question: 'What happens if my payment fails?',
    answer: `If a payment fails, SuperAGI will attempt to retry the charge for five days. Users will receive in-app notifications prompting them to update their payment method.\n\nIf payment is not completed within five days, access to paid features will be paused until the payment issue is resolved.`,
  },
  {
    question: 'How can I contact support for billing-related questions?',
    answer: ['For billing-related inquiries, users can:', '• Email support@superagi.com for assistance.'],
  },
];
